// extracted by mini-css-extract-plugin
export default {"container":"GenericSuccessModalContent_container__WyCCL","image":"GenericSuccessModalContent_image__X79LU"};